import { Divisa } from "src/app/models/Divisa";

export function esTipoCambioValido(value: unknown): boolean {
	return value !== null && value !== "" && Number.isFinite(Number(value)) && Number(value) > 0;
}
export function obtenerCotizacion(divisas: Divisa[], moneda: string): number | null {
	const divisa = (divisas || []).find((item) => {
		const nombre = (item?.nombre || "")
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.trim()
			.toUpperCase();
		return nombre === moneda || (moneda === "USD" && ["DOLAR", "DOLAR OBSERVADO", "DOLAR USA"].includes(nombre)) || (moneda === "EUR" && nombre === "EURO");
	});
	return esTipoCambioValido(divisa?.valorClp) ? Number(divisa.valorClp) : null;
}
